var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99984 3.33352V12.6669H13.9998V3.33352H1.99984ZM1.33317 2.00018C0.964981 2.00018 0.666504 2.29866 0.666504 2.66685V13.3335C0.666504 13.7017 0.964981 14.0002 1.33317 14.0002H14.6665C15.0347 14.0002 15.3332 13.7017 15.3332 13.3335V2.66685C15.3332 2.29866 15.0347 2.00018 14.6665 2.00018H1.33317Z",
    fill: "#003C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4219 6.07235C10.5376 6.06523 10.6505 6.11317 10.7325 6.20416L14.8066 10.728C14.9657 10.9046 14.9657 11.1911 14.8066 11.3677C14.6475 11.5444 14.3895 11.5444 14.2304 11.3677L10.4782 7.20131L7.50328 11.3304C7.43088 11.4309 7.32338 11.4924 7.20767 11.4995C7.09197 11.5067 6.97901 11.4587 6.89706 11.3677L5.14811 9.4257L1.76952 13.1773L1.19336 12.5375L4.86003 8.46606C5.01913 8.28939 5.27708 8.28939 5.43619 8.46606L7.15136 10.3706L10.1263 6.24144C10.1987 6.14096 10.3062 6.07946 10.4219 6.07235Z",
    fill: "#003C84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5185 13.7621L1.48145 13.3097L5.14811 9.23827L7.18515 10.5954L10.4444 6.52399L14.5185 10.5954V13.7621Z",
    fill: "#003C84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70361 5.49344C2.70361 4.81332 3.22595 4.26196 3.87028 4.26196C4.51461 4.26196 5.03695 4.81332 5.03695 5.49344C5.03695 6.17357 4.51461 6.72493 3.87028 6.72493C3.22595 6.72493 2.70361 6.17357 2.70361 5.49344Z",
    fill: "#003C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPhoto);
export default __webpack_public_path__ + "static/media/viewPhoto.83784013d824651b865df1b9b1563c79.svg";
export { ForwardRef as ReactComponent };